import React, { useState } from 'react';
import strings from 'strings';
import ProfileTableLayout from 'UI/components/organisms/inventoryProfiles/ProfileTableLayout';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { TabKeys } from 'UI/constants/entityTypes';

import { ChangeLogsContent } from './ChangeLogsContent';
import { ChangeLogsColumns } from './columns';

/** @typedef {import('types/app').ProfileDataTableProps} ProfileDataTableProps */

/**
 * @param {Object} props
 * @param {ProfileDataTableProps} props.DataTableProps
 * @param {string} props.tablePreferencesKey
 * @param {number} props.entityId
 * @param {string} props.profileModule
 */
const ChangeLogsTab = ({ DataTableProps, profileModule, entityId, tablePreferencesKey }) => {
  const [uiState, setUiState] = useState({
    isChangeLogOpen: false,
    selectedChangeLogId: null
  });

  const handleChangeLogClick = changeLogId => {
    setUiState({
      isChangeLogOpen: true,
      selectedChangeLogId: changeLogId
    });
  };

  const handleCloseDrawer = () =>
    setUiState({
      isChangeLogOpen: false,
      selectedChangeLogId: null
    });

  const finalActions = [
    {
      name: 'view',
      callback: handleChangeLogClick,
      pickId: true
    }
  ];

  const changeLogContentEndpoint =
    DataTableProps?.endpoint &&
    `${DataTableProps?.endpoint}/${uiState.selectedChangeLogId}?includes=vCreatedBy`;

  return (
    <>
      <ProfileTableLayout
        DataTableProps={DataTableProps}
        finalActions={finalActions}
        initialColumns={ChangeLogsColumns}
        orderByOptions={{ column: 'created_at', direction: 'desc' }}
        profileModule={profileModule}
        search={false}
        tabKey={TabKeys.ChangeLogs}
        tablePreferencesKey={tablePreferencesKey}
      />
      {entityId && (
        <FPDrawer
          onClose={handleCloseDrawer}
          CardHeaderProps={{
            title: strings.inventoryProfiles.sections.tabs.changeLogs.sectionName
          }}
          FPDrawerProps={{ open: uiState.isChangeLogOpen }}
        >
          <div role="presentation">
            {uiState.selectedChangeLogId && (
              <ChangeLogsContent endpoint={changeLogContentEndpoint} />
            )}
          </div>
        </FPDrawer>
      )}
    </>
  );
};

export default ChangeLogsTab;
